/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { GuildQuest } from './GuildQuest';
import {
    GuildQuestFromJSON,
    GuildQuestFromJSONTyped,
    GuildQuestToJSON,
    GuildQuestToJSONTyped,
} from './GuildQuest';

/**
 * 
 * @export
 * @interface GetGuildQuestsResponse
 */
export interface GetGuildQuestsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetGuildQuestsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<GuildQuest>}
     * @memberof GetGuildQuestsResponse
     */
    quests: Array<GuildQuest>;
}

/**
 * Check if a given object implements the GetGuildQuestsResponse interface.
 */
export function instanceOfGetGuildQuestsResponse(value: object): value is GetGuildQuestsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('quests' in value) || value['quests'] === undefined) return false;
    return true;
}

export function GetGuildQuestsResponseFromJSON(json: any): GetGuildQuestsResponse {
    return GetGuildQuestsResponseFromJSONTyped(json, false);
}

export function GetGuildQuestsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGuildQuestsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'quests': ((json['quests'] as Array<any>).map(GuildQuestFromJSON)),
    };
}

export function GetGuildQuestsResponseToJSON(json: any): GetGuildQuestsResponse {
    return GetGuildQuestsResponseToJSONTyped(json, false);
}

export function GetGuildQuestsResponseToJSONTyped(value?: GetGuildQuestsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'quests': ((value['quests'] as Array<any>).map(GuildQuestToJSON)),
    };
}

